import { styled, css } from 'styled-components';
import { Image } from '@/shared/ui/image';

const flexCenterColumn = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const WrapperNotPay = styled.div`
  ${flexCenterColumn}
  gap: 16px;
  padding: 18px;
  margin: auto;
  height: 100%;
  width: 100%;
`;

const Blocknfo = styled.div`
  ${flexCenterColumn}
  gap: 8px;
`;

const CloseIcon = styled(Image)`
  ${flexCenterColumn}
  padding: 20px;
  width: 80px;
  height: 80px;
  gap: 10px;
  border-radius: 1000px;
  background: var(--Red, #da4444);
`;

const Sum = styled.span`
  color: #fff;
`;

export { WrapperNotPay, Sum, Blocknfo, CloseIcon };
